import { render, staticRenderFns } from "./PerPageSelect.vue?vue&type=template&id=4deca9bd&scoped=true&lang=pug&"
import script from "./PerPageSelect.vue?vue&type=script&lang=js&"
export * from "./PerPageSelect.vue?vue&type=script&lang=js&"
import style0 from "./PerPageSelect.vue?vue&type=style&index=0&id=4deca9bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deca9bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
